define('OutSystems/ReactWidgets/TableRecords',["require", "exports", "tslib", "OutSystems/ClientRuntime/ObjectExtensions", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/Widget", "prop-types", "react"], function (require, exports, tslib_1, ObjectExtensions, Settings_1, Widget_1, PropTypes, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TableRecords = void 0;
    var TableRecords = (function (_super) {
        tslib_1.__extends(TableRecords, _super);
        function TableRecords() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                sortAttribute: "",
            };
            return _this;
        }
        TableRecords.prototype.setDataHeaderInRowCells = function () {
            var _a;
            var rows = this.body ? this.body.children : [];
            var headerCells = this.header ? this.header.getElementsByTagName("th") : [];
            for (var h = 0; h < headerCells.length; h++) {
                var headerCell = headerCells[h];
                for (var r = 0; r < rows.length; r++) {
                    var row = rows[r];
                    (_a = row.children[h]) === null || _a === void 0 ? void 0 : _a.setAttribute("data-header", headerCell.innerText);
                }
            }
        };
        TableRecords.prototype.componentDidMount = function () {
            this.setDataHeaderInRowCells();
        };
        TableRecords.prototype.componentDidUpdate = function () {
            this.setDataHeaderInRowCells();
        };
        TableRecords.prototype.renderHeader = function () {
            var _this = this;
            var tableHeaderAttributes = {
                className: this.props.styleHeader,
            };
            if (this.props.showHeader) {
                return (React.createElement("thead", { ref: function (elem) { return (_this.header = elem); } },
                    React.createElement("tr", tslib_1.__assign({}, tableHeaderAttributes), this.props.placeholders.headerRow.render())));
            }
            return null;
        };
        TableRecords.prototype.renderRows = function () {
            var _this = this;
            var tableRowAttributes = {
                className: this.props.styleRow,
            };
            if (this.props.source.length > 0) {
                return (React.createElement("tbody", { ref: function (elem) { return (_this.body = elem); } }, this.props.placeholders.row.render(this, this.props.source, function (element, index) {
                    return React.createElement("tr", tslib_1.__assign({}, tableRowAttributes), element);
                }, undefined, undefined, Settings_1.getEnvParams().PreserveListItemReactKey)));
            }
            return null;
        };
        TableRecords.prototype.onSort = function (sortAttribute) {
            this.setState({ sortAttribute: sortAttribute });
            this.props.onSort(sortAttribute);
        };
        TableRecords.prototype.getChildContext = function () {
            var _this = this;
            var result = _super.prototype.getChildContext.call(this);
            if (!!this.props.onSort) {
                result.onTableRecordsSort = function (sortAttribute) { return _this.onSort(sortAttribute); };
                result.tableRecordsCurrentSortAttribute = this.state.sortAttribute;
            }
            return result;
        };
        TableRecords.prototype.render = function () {
            var tableAttributes = {
                className: this.props.style,
                role: "grid",
            };
            this.fillWithBuiltinProperties(tableAttributes);
            return (React.createElement("table", tslib_1.__assign({}, tableAttributes),
                this.renderHeader(),
                this.renderRows()));
        };
        TableRecords.childContextTypes = ObjectExtensions.assign({
            onTableRecordsSort: PropTypes.func,
            tableRecordsCurrentSortAttribute: PropTypes.string,
        }, Widget_1.Widget.childContextTypes);
        TableRecords = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], TableRecords);
        return TableRecords;
    }(Widget_1.Widget));
    exports.TableRecords = TableRecords;
});
//# sourceMappingURL=TableRecords.js.map;
